import React, { useMemo } from 'react';
import { observer } from 'mobx-react';

import { reportingFormsStore } from '@stores/reportingFormsStore';

import { Breadcrumbs } from './Breadcrumbs';
import { ReportingFormFive } from './ReportingFormFive';

import styles from './ReportingForms.module.scss';

export const ReportingFormsComponent = (): JSX.Element => {
  const { lastPagesParam } = reportingFormsStore;

  const renderForm = useMemo(() => {
    switch (lastPagesParam.typeForm) {
      case 'level5':
        return <ReportingFormFive />;

      default:
        return null;
    }
  }, [lastPagesParam.typeForm]);

  return (
    <div className={styles.forms}>
      <Breadcrumbs />
      {renderForm}
    </div>
  );
};

export const ReportingForms = observer(ReportingFormsComponent);
